export class BasePlugin {
    /**
     * @type {?CookieConsent}
     */
    cookieConsent = null;

    /**
     * @type {?HTMLDialogElement}
     */
    dialog = null;

    initialize(cookieConsent) {
        this.cookieConsent = cookieConsent;
        this.dialog = this.cookieConsent.dialog;
    }

    destroy() {
        this.cookieConsent = null;
        this.dialog = null;
    }
}
